// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1CbRl","colMin":"styles_colMin__2I_Rh","colCheckbox":"styles_colCheckbox__2JEyx"};